import * as React from 'react';
import { Box, BoxProps } from '@mui/material';

export function CerebroForm({
	children,
	onSubmit,
	scrollbarOffset = 0,
	flatIndicator = false,
	...props
}: CerebroFormProps) {
	const handleSubmit: CerebroFormProps['onSubmit'] = event => {
		onSubmit?.(event);
	};

	return (
		<Box component="form" onSubmit={handleSubmit} {...props}>
			{children}
		</Box>
	);
}

type CerebroFormProps = React.PropsWithChildren<
	Omit<BoxProps<'form'>, 'component'> & {
		flatIndicator?: boolean;
		scrollbarOffset?: number;
	}
>;
